import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from '../../service/data/account.service';
import { MessageService } from '../../../core/service/message.service';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { LanguageService } from '../../../core/service/language.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _accountService: AccountService,
    private _languageService: LanguageService,
    private _messageService: MessageService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {}

  private _id: string;
  private _ticket: string;
  form: FormGroup;

  private _createForm() {
    this.form = this._fb.group({
      confirmPassword: this._fcf.createMandatory('RESET_PASSWORD_FORM.CONFIRM_PASSWORD_LABEL', ''),
      password: this._fcf.createMandatory('RESET_PASSWORD_FORM.PASSWORD_LABEL', ''),
    });
  }

  ngOnInit() {
    this._createForm();
    this._route.queryParams.subscribe(map => {
      this._id = map['uid'];
      this._ticket = map['ticket'];
      const cl = map['cl'];
      if (cl) {
        this._languageService.setLanguage(parseInt(cl));
      }
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.form.controls['password'].value != this.form.controls['confirmPassword'].value) {
      this.form.controls['confirmPassword'].setErrors({ mismatch: { message: 'ERROR.PASSWORD_MISMATCH_ERROR' } });
      this.form.controls['password'].setErrors({ mismatch: { message: 'ERROR.PASSWORD_MISMATCH_ERROR' } });
      return;
    }

    let model = {
      newPassword: this.form.controls['password'].value,
      ticket: this._ticket,
      userId: this._id,
    };
    this._accountService.resetPassword(model).subscribe(
      () => this._router.navigate(['login']),
      error => this._messageService.showError(error)
    );
  }
}
